import React from 'react';
import Page from '../components/Page';
import { FormattedMessage } from 'react-intl';

const Sobre = (props) => {
   return(
      <Page view="sobre" bg="/assets/img/sobre-bg.jpg">
         <h1><FormattedMessage id="sobre.h1" /></h1>
         <p><FormattedMessage id="sobre.p1" /></p>
         <h3><FormattedMessage id="sobre.h3_1" /></h3>
         <p><FormattedMessage id="sobre.p2" /></p>
         <h3><FormattedMessage id="sobre.h3_2" /></h3>
         <p><FormattedMessage id="sobre.p3" /></p>
         <h3><FormattedMessage id="sobre.h3_3" /></h3>
         <p><FormattedMessage id="sobre.p4" /></p> 
      </Page>
   )
}

export default Sobre;